import __request__ from "routing/request";
export function trigger(JSONbody) {
  return __request__("POST", "/system/jobs", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function list() {
  return __request__("GET", "/system/jobs", null, {}, {
    "Accept": ["application/json"]
  });
}
export function acknowledgeJob(jobId) {
  return __request__("DELETE", `/system/jobs/acknowledge/${jobId}`, null, {}, {
    "Accept": []
  });
}
export function get(jobId) {
  return __request__("GET", `/system/jobs/${jobId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function cancel(jobId) {
  return __request__("DELETE", `/system/jobs/${jobId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
